import controller from './chart-counting.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    controller,
    template
};
